// Get data for populating dropdowns
// TODO Get season, medium, and entry data for older years and prepare it
function getAwardProgram(handle) {
    const awards = {
        "clio-sports-of-the-year-2": { vertical: "Clio Sports", award: "of the year" },
        "clio-sports-gold": { vertical: "Clio Sports", award: "gold" },
        "clio-sports-grand": { vertical: "Clio Sports", award: "grand" },
        "clio-sports-silver": { vertical: "Clio Sports", award: "silver" },
        "clio-sports-bronze": { vertical: "Clio Sports", award: "bronze" },

        "clio-fashion-beauty-of-the-year-1": { vertical: "Clio Fashion & Beauty", award: "of the year" },
        "clio-fashion-beauty-grand": { vertical: "Clio Fashion & Beauty", award: "grand" },
        "clio-fashion-beauty-gold": { vertical: "Clio Fashion & Beauty", award: "gold" },
        "clio-fashion-beauty-silver": { vertical: "Clio Fashion & Beauty", award: "silver" },
        "clio-fashion-beauty-bronze": { vertical: "Clio Fashion & Beauty", award: "bronze" },

        "clio-cannabis-of-the-year-2": { vertical: "Clio Cannabis", award: "of the year" },
        "clio-cannabis-grand": { vertical: "Clio Cannabis", award: "grand" },
        "clio-cannabis-gold": { vertical: "Clio Cannabis", award: "gold" },
        "clio-cannabis-silver": { vertical: "Clio Cannabis", award: "silver" },
        "clio-cannabis-bronze-1": { vertical: "Clio Cannabis", award: "bronze" },

        "clio-awards-of-the-year-2": { vertical: "Clio Awards", award: "of the year" },
        "clio-awards-grand": { vertical: "Clio Awards", award: "grand" },
        "clio-awards-gold": { vertical: "Clio Awards", award: "gold" },
        "clio-awards-silver": { vertical: "Clio Awards", award: "silver" },
        "clio-awards-bronze": { vertical: "Clio Awards", award: "bronze" },

        "clio-entertainment-of-the-year-2": { vertical: "Clio Entertainment", award: "of the year" },
        "clio-entertainment-grand": { vertical: "Clio Entertainment", award: "grand" },
        "clio-entertainment-gold": { vertical: "Clio Entertainment", award: "gold" },
        "clio-entertainment-silver": { vertical: "Clio Entertainment", award: "silver" },
        "clio-entertainment-bronze": { vertical: "Clio Entertainment", award: "bronze" },

        "clio-music-of-the-year-2": { vertical: "Clio Music", award: "of the year" },
        "clio-music-grand": { vertical: "Clio Music", award: "grand" },
        "clio-music-gold": { vertical: "Clio Music", award: "gold" },
        "clio-music-silver": { vertical: "Clio Music", award: "silver" },
        "clio-music-bronze": { vertical: "Clio Music", award: "bronze" },

        "clio-health-of-the-year-2": { vertical: "Clio Health", award: "of the year" },
        "clio-health-grand": { vertical: "Clio Health", award: "grand" },
        "clio-health-gold": { vertical: "Clio Health", award: "gold" },
        "clio-health-silver": { vertical: "Clio Health", award: "silver" },
        "clio-health-bronze": { vertical: "Clio Health", award: "bronze" }
    };

    const container = document.querySelector("#product-dropdown-container");
    const parsedHandle = container?.dataset?.productHandle || '';
    const award = awards[handle]?.award || 'No award';
    const program = awards[handle]?.vertical || 'No vertical';
    return [award, program];
}

// function getYears(program, award) {
//     return ["2025", "2024", "2023"];
// }

// function getMediums(program, award, year) {
//     return [{id: 1, mediumName:"Film"}, {id: 2, mediumName: "Print"}];
// }

// function getEntries(mediumId, award) {
//     return [{id: 444, brandName: "ABC Brand", title: "coolTitle"}];
// }

// function getCredits(entryId) {
//     const results = {individuals: [
//         {
//             "EntryId": 1,
//             "FullName": " FRED & FARID",
//             "CompanyName": " FRED & FARID",
//             "JobTitle": "Chief Creative Officer"
//         },
//         {
//             "EntryId": 1,
//             "FullName": "BILLY LIAO",
//             "CompanyName": "FRED & FARID Shanghai",
//             "JobTitle": "Art Director"
//         },
//         {
//             "EntryId": 1,
//             "FullName": " FENG HUANG",
//             "CompanyName": "FRED & FARID Shanghai",
//             "JobTitle": "Executive Creative Director"
//         },
//         {
//             "EntryId": 1,
//             "FullName": "Joseph Burg",
//             "CompanyName": "Sony Pictures Entertainment",
//             "JobTitle": "Executive Producer"
//         },
//         {
//             "EntryId": 1,
//             "FullName": "Joseph Mueller",
//             "CompanyName": "",
//             "JobTitle": "Producer"
//         },
//         {
//             "EntryId": 1,
//             "FullName": "Nicolás Massimino",
//             "CompanyName": "Mercado Mccann",
//             "JobTitle": "Chief Creative Officer"
//         },
//         {
//             "EntryId": 1,
//             "FullName": "Agustín Coste",
//             "CompanyName": "Mercado Mccann",
//             "JobTitle": "Managing Director"
//         },
//         {
//             "EntryId": 1,
//             "FullName": "Leila Concistre",
//             "CompanyName": "Mercado Mccann",
//             "JobTitle": "Executive Director"
//         },
//         {
//             "EntryId": 1,
//             "FullName": "Agustín Borgognoni",
//             "CompanyName": "Mercado Mccann",
//             "JobTitle": "Production Manager"
//         },
//         {
//             "EntryId": 1,
//             "FullName": "Mariano Malvasio",
//             "CompanyName": "TyC Sports",
//             "JobTitle": "Marketing"
//         }
//     ], 
//     companies: [
//         {
//             "EntryId": 1,
//             "CompanyName": "TyC Sports",
//             "CompanyType": "Marketing"
//         },
//         {
//             "EntryId": 1,
//             "CompanyName": "Elemeno Sports",
//             "CompanyType": "Marketing"
//         }
//     ]}

const STATIC_BASE = "https://store-data.clios.com/static";

function slugify(str) {
    return String(str || "")
        .trim()
        .toLowerCase()
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

async function getYears(program, award) {
    const programSlug = slugify(program);
    const awardSlug = slugify(award);
    let result = [];
    if (programSlug === "clio-music" && (awardSlug === "grand"))
        {
            result = [
                "2026",
                "2025",
                "2024",
                "2022",
                "2020",
                "2019",
                "2018",
                "2017",
                "2016",
                "2015"
                ]
        } 
    else {
        const res = await fetch(`${STATIC_BASE}/years/${programSlug}/${awardSlug}.json`);
        if (!res.ok) return [];
        result = res.json();
    }
    return result;
}

async function getMediums(program, award, year) {
    const programSlug = slugify(program);
    const awardSlug = slugify(award);
    const res = await fetch(`${STATIC_BASE}/mediums/${programSlug}/${awardSlug}/${year}.json`);
    if (!res.ok) return [];
    return res.json();
}

async function getEntries(mediumId, award) {
    const awardSlug = slugify(award);
    const res = await fetch(`${STATIC_BASE}/entries/medium-${mediumId}/${awardSlug}.json`);
    if (!res.ok) return [];
    return res.json();
}

async function getCredits(entryId) {
    const res = await fetch(`${STATIC_BASE}/credits/${entryId}.json`);
    if (!res.ok) return { companies: [], individuals: [] };
    // return res.json();

    const result = await res.json();

//    console.log(result);

    const creditedCompanies = [
        // ...results.individuals.map(i => ({companyName: i.CompanyName.trim(), companyType: null})),
          ...result.companies.map(c => ({companyName: c.CompanyName.trim(), companyType: c.CompanyType})) 
    ].filter(company => company.companyName !== '');

    const creditedCompanyNames = creditedCompanies.map(c => c.companyName);

    const individualCompanies = [
        ...result.individuals.map(i => ({companyName: i.CompanyName.trim(), companyType: null}))
    ].filter(company => company.companyName !== '' && !creditedCompanyNames.includes(company.companyName));
    
    const allCompanies = [...creditedCompanies, ...individualCompanies];
    const allIndividuals = [...result.individuals.map(i => ({fullName: i.FullName.trim(), jobTitle: i.JobTitle.trim()}))]

    const dedupedCompanies = [...(new Set(allCompanies.map(e => JSON.stringify(e))))].map(e => JSON.parse(e));
    const dedupedIndividuals = [...(new Set(allIndividuals.map(e => JSON.stringify(e))))].map(e => JSON.parse(e));

    // console.log(allCompanies, dedupedCompanies)
    return {companies: dedupedCompanies, individuals: dedupedIndividuals};
}

const clioOfTheYearYears = [
  "1960","1961","1962","1963","1964","1965","1966","1967","1968","1969",
  "1970","1971","1972","1973","1974","1975","1976","1977","1978","1979",
  "1980","1981","1982","1983","1984","1985","1986","1987","1988","1989",
  "1990","1991","1992","1993","1994","1995","1996","1997","1998","1999",
  "2000","2001","2002","2003","2004","2005","2006","2007","2008","2009",
  "2010","2011","2012","2013","2014","2015","2016","2017","2018","2019",
  "2020/2021","2022","2023","2024","2025"
];

const clioOfTheYearAwards = [
  "Advertiser of the Year",
  "Agency of the Year",
  "Network of the Year",
  "Independent Agency of the Year",
  "Production Company of the Year"
];

// Award and Statue >> (Years) >> 
// Award + Year >> RootProgram >>
// RootProgram + Statue >> (Mediums) >>
// MediumId >> (Entries) Id, Brand, Title >>
// EntryId >> (Credits)